var _path, _g, _path2, _path3, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKidsPlay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2992_969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2992_969)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2992_969",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 55,
    height: 55
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H55V55H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2992_969)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.303 37.5815L32.9937 51.8891H54.1933L47.8277 18.043H41.5348",
    stroke: "#C7A386",
    strokeWidth: 1.26923,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1252 46.5835L22.0791 51.8872H0.805908L20.2674 18.041H37.9588",
    stroke: "#C7A386",
    strokeWidth: 1.26923,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5357 18.041L26.728 43.7903",
    stroke: "#C7A386",
    strokeWidth: 1.26923,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2992_969",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 55,
    height: 55
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H55V55H0V0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2992_969)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.5365 18.0399V11.8105L22.075 45.6567V51.8861",
    stroke: "#BC8639",
    strokeWidth: 2.53846,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2627 18.0399V11.8105L0.80542 45.6567V51.8861L20.2627 18.0399Z",
    stroke: "#BC8639",
    strokeWidth: 2.53846,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8255 18.0397V6.26124C47.8252 5.42693 47.4937 4.62686 46.9038 4.03692C46.3138 3.44698 45.5138 3.11546 44.6794 3.11523C43.8451 3.11523 43.0449 3.44668 42.4549 4.03667C41.8649 4.62666 41.5334 5.42687 41.5334 6.26124V11.8103",
    stroke: "#BC8639",
    strokeWidth: 2.53846,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2615 11.8103V6.26124C20.2609 5.84802 20.3421 5.43877 20.5002 5.057C20.6583 4.67524 20.8904 4.32849 21.1829 4.0367C21.4747 3.74411 21.8215 3.51208 22.2032 3.35395C22.585 3.19581 22.9943 3.11469 23.4075 3.11524C24.2417 3.11569 25.0416 3.44728 25.6315 4.03717C26.2214 4.62707 26.553 5.42701 26.5535 6.26124V8.75654",
    stroke: "#BC8639",
    strokeWidth: 2.53846,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5549 18.0395V11.9785",
    stroke: "#BC8639",
    strokeWidth: 2.53846,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4443 26.6328H36.5955",
    stroke: "#BC8639",
    strokeWidth: 2.53846,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0831 35.3457H31.5852",
    stroke: "#BC8639",
    strokeWidth: 2.53846,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7213 44.0566H31.5217",
    stroke: "#BC8639",
    strokeWidth: 2.53846,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2992_969"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2992_969"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKidsPlay);
export default __webpack_public_path__ + "static/media/kids-play.7dde79a86d3b1f4d25bf2215736319bc.svg";
export { ForwardRef as ReactComponent };